import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { connect } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { Collapse } from 'bootstrap';
import { DisplaySearchCriteria, PeriodSelectionWithCustom} from "../../../components/TapUi/index";
import DownloadFile from "../../../services/DownloadFile";
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapSelect from "../../../components/ui/TapSelect";
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Helmet } from 'react-helmet';
import DateService from '../../../services/DateService';
import React from 'react';
import CommonOwnerShipCategorySearch from '../../assets/CommonOwnerShipCategorySearch';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

class AssetSegrationReport extends AppBaseComponent {
    
    constructor(props) {
        super(props);
        this.reportUrl                      =   IAM_API_BASE_URL_2 + '/report/asset-utillisation';

        this.reportFilterFormInitialState   =   {
            site_group_ids                                :   [],
            search_site_ids                               :   [],
            'asset_group_ids'                             :    [],
            search_asset_type_ids                         :   [],
            search_asset_matrix_ids                       :   [],
            search_manufacturer_ids                       :   [],
            search_models                                 :   [],
            search_variant                                :   [],
            search_asset_ids                              :   [],
            search_status                            :   [],
            search_asset_type                             :   '',
            date_range                                    :   '',
            date_range_start                              :   '',
            date_range_end                                :   '',
               search_owner_category: "",
            search_owner_id: [],
            search_owner_company: ''
        };
        
        this.reportFilterFormLabel          =   {
            site_group_ids                                :   'Site Groups : ',
            search_site_ids                               :   'Sites : ',
            'asset_group_ids'                             :   'Asset Type Groups : ',
            search_asset_type_ids                         :   'Asset Type : ',
            search_asset_matrix_ids                       :   'Asset Matrix : ',
            search_manufacturer_ids                       :   'Manufacturer : ',
            search_models                                 :   'Models : ',
            search_variant                                :   'Variants : ',
            search_asset_ids                              :   'Assets : ',
            search_asset_type                             :   'Asset Type : ',
            search_status                              :   'Utilization Status (based on Total Hrs) : ',
            search_asset_category                        :   'Asset Category : ',
              search_owner_category: "Ownership Category : ",
            search_owner_id: "Owner : ",
            search_owner_company: "Owner Company : ",
            date_range                                    :   'Date Range :  ',
        };
         
        this.state                          =   {
            formDataLoaded                      :   false,
            reportDownloadBtn                   :   false,
            reportDownloading                   :   false,
            all_warehouses                      :   [],
            reportFilterForm                    :   {...this.reportFilterFormInitialState},
            submittedReportFilterForm           :   {...this.reportFilterFormInitialState},
            listing_loading                     :   false,
            listingData                         :   [],
            listingMeta                         :   null, 
            iam_asset_types                     :   [],
            iam_user_sites                      :   [],
            iam_asset_matrix                    :   [],
            iam_manufactures                    :   [],
            iam_asset_variants                  :   [],
            iam_models                          :   [],
            searchedAssets                      :   [],
            formSearchedElems                   :   [],
            allOwnershipCategory                :   [],
            allOwnersList                       :   [],
            allSiteGroupsList                   :   [],
            allAssetTypesGroupsList             :   [],
            all_periods                         :   [],
            notes                               :   "",
            allStatus                           :   [],
            reportData                          :   null,     
            criteriaHeight                      :   0     ,
                allOwnerCategoryList: [],
            allOwnersList: [],
            searchedCustomer: null,
            searchedVendor: null,                    
           
        };
        this.criteriaRef                =   React.createRef();
    }
    
    componentDidMount(){
        setTimeout(() => {
            this.initilaizeAppDataToFilterForm(this.props); 
        },1000);
    }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            this.updateCriteriaHeight();
        }
    }
    initilaizeAppDataToFilterForm           =   (props)  =>  {
        const report_name   =   'asset_utilization_report';
        const reportData    =   props?.report_listing.length > 0 ? props.report_listing.filter(d => d.key === report_name) : [];
        
        HttpAPICall.withAthorization('GET',this.reportUrl, this.props.access_token, {action:"formData"}, null, (response) => {
            this.setState({
                reportData                  :   reportData.length > 0 ? reportData[0] : null,
                access_token                :   props.access_token,
                formDataLoaded              :   true,
                notes                   :   response.data.notes ? response.data.notes : "",
                iam_asset_types         :   props.iam_asset_types ? props.iam_asset_types.map((at) => { return {value: at.id, label: at.asset_type_name}}) : [],
                iam_user_sites          :   props.iam_user_sites ? props.iam_user_sites.map((s) => { return {value: s.id, label: `${s.site_name} (${s.site_code})`}}) : [],
                iam_asset_matrix        :   props.iam_asset_matrix ? props.iam_asset_matrix.map(am => { return {value: am.id, label: am.asset_matrix_unique_id}}) : [],
                iam_manufactures        :   props.iam_manufactures ? props.iam_manufactures.map((m) => { return {value: m.id, label: m.manufacturer_name}}) : [],
                iam_asset_variants          :   props.iam_asset_variants ? props.iam_asset_variants.map((v) => { return {value: v, label: v}}) : [],
                iam_models                   :   props.iam_models ? props.iam_models.map((m) => { return {value: m.id, label: m.model_name}}) : [],
                allAssetTypesGroupsList      :   props.asset_groups && props.asset_groups.length > 0 ? props.asset_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_asset_types: oc.asset_type_ids }) }) : [],
                allOwnershipCategory          :   response.data.ownership_category && response.data.ownership_category.length > 0 ? response.data.ownership_category.map(oc => {return({value:oc.key,label : oc.name})}) : [],
                allOwnersList                 :   response.data.owners && response.data.owners.length > 0 ? response.data.owners.map(oc => {return({value:oc.id,label : oc.name})}) : [],
                allSiteGroupsList             :   response.data.site_groups  &&  response.data.site_groups.length > 0 ?  response.data.site_groups.map(oc => {return({value:oc.id,label : oc.name,linked_sites : oc.site_ids})}) : [],
                all_periods                 :      response.data.periods && response.data.periods.length > 0 ? response.data.periods : [],
                allStatus                 :   response.data.status && response.data.status.length > 0 ? response.data.status.map(oc => {return({value:oc.key,label : oc.name})}) : [],
            }, () => {
                let status = [];
                let ParamObject = new URLSearchParams(this.props.location ? this.props.location.search : null);
                let search_site_ids = [];
                let updateFilterForm={}
                
                if (ParamObject.get('status') || ParamObject.get('search') || ParamObject.get('date_range') || ParamObject.get('search_site_ids') ) {
                        
                            status = ParamObject.get('status') ? ParamObject.get('status') : [];
                            
                        
                        if (ParamObject.get('date_range')) {
                            let date_range = ParamObject.get('date_range');
                            let period = this.state.all_periods.find(p => p.key == ParamObject.get('date_range'));
                            let startDate = period && period.dateFromYmd && moment(period.dateFromYmd).format('YYYY-MM-DD');
                            let endDate = period && period.dateToYmd && moment(period.dateToYmd).format('YYYY-MM-DD')
        
                            updateFilterForm['date_range']  = date_range;
                            updateFilterForm['date_range_start']  = startDate;
                            updateFilterForm['date_range_end']  = endDate ;
                               
                    
                        }

                        if (ParamObject.get('search_site_ids')) {
                            let site = this.state.iam_user_sites.find(us => us.value == ParamObject.get('search_site_ids'));
                            search_site_ids = [site.value];
                            
                        }
                      
                        setTimeout(() => {
                            this.setState({
                         
                                reportFilterForm        :       {
                                    ...this.state.reportFilterForm,
                                    ...updateFilterForm,
                                    search_status     :   ParamObject.get('search') ? status :  [status],
                                    search_site_ids     :       search_site_ids,
                                }
                            }, () => {
    
                                this.reportFilterFormSubmit()
                            });
                        },1500);
                    }else {
                        this.reportFilterhandler()
                    }
                   // this.reportFilterhandler()
            });
        });
    }
     handleOwnerCategoryChange = (ownerCategoryData) => {
        this.setState(prevState => ({
            reportFilterForm: {
                ...prevState.reportFilterForm,
                ...ownerCategoryData
            }
        }));
    }
    handleOwnerDataLoad = (ownerData) => {

        this.setState({
            allOwnerCategoryList: ownerData.allOwnerCategoryList || [],
            allOwnersList: ownerData.allOwnersList || [],
            searchedCustomer: ownerData.searchedCustomer || [],
            searchedVendor: ownerData.searchedVendor || []
        });
    }
    reportFilterFormSubmit                  =   (event=null,merge_list=false)  =>  {
        event && event.preventDefault();
        event && this.reportFilterhandler(true);
       
        let serachFormKeys                  =   Object.keys(this.state.reportFilterForm);
        let searchedElems                   =   [];
        let itemSearchParams                =   {};
       
        serachFormKeys.map((key)        =>  {
            let label                       =   this.reportFilterFormLabel[key];
            let value                       =   this.state.reportFilterForm[key];
            if(value && value.toString().length > 0) {
            
                itemSearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                    
                    if(key == 'site_group_ids') {
                        show_val            =   this.state.allSiteGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ')
                    }
                    if(key == 'search_asset_ids') {
                        show_val            =   this.state.searchedAssets ? this.state.searchedAssets.map(s => s.display_label).join(', ') : '';
                    }
                    if(key == 'asset_group_ids') {
                        show_val            =   this.state.allAssetTypesGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_asset_type_ids') {
                        show_val            =   this.state.iam_asset_types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_site_ids') {
                        show_val            =   this.state.iam_user_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_asset_matrix_ids') {
                        show_val            = this.state.iam_asset_matrix.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_manufacturer_ids') {
                        show_val            = this.state.iam_manufactures.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_models') {
                        show_val            = this.state.iam_models.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                     if (key === "search_owner_category") {
                        const category = this.state.allOwnerCategoryList.find(oc => oc.value === value);
                        show_val = category ? category.label : value;
                    }
                    if (key === "search_owner_id") {
                        let ownerLabel = '';
                        if (this.state.reportFilterForm.search_owner_category === "owned") {
                            const owner = this.state.allOwnersList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                            ownerLabel = owner ? owner : value;
                        } else if (this.state.reportFilterForm.search_owner_category === "customer") {
                            ownerLabel = this.state.searchedCustomer ? this.state.searchedCustomer.map(s => s.display_label).join(', ') : '';

                        } else if (this.state.reportFilterForm.search_owner_category === "vendor") {

                            ownerLabel = this.state.searchedVendor ? this.state.searchedVendor.map(s => s.vendor?.name).join(', ') : '';

                        }
                        show_val = ownerLabel;
                    }
                    if(key == 'search_status') {
                        show_val            = this.state.allStatus.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'date_range') {
                        let start_range = moment(this.state.reportFilterForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(this.state.reportFilterForm.date_range_end).format('DD-MMM-YYYY')
                         show_val = `${this.state.reportFilterForm.date_range} (${start_range} - ${end_range})`
                        // show_val = this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                        // show_val = this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedReportFilterForm           :   {...this.state.reportFilterForm},
            formSearchedElems                   :   searchedElems
        }, () => {
           this.loadListingTblData(0,merge_list);
        });
    }

    loadListingTblData                      =   (page=0,merge_list=false) => {
        this.setState({
            listingData                 :   merge_list == true ? [] : this.state.listingData,
            listingMeta                 :   merge_list == true ? null : this.state.listingMeta,
            listing_loading             :   true,
            reportDownloadBtn           :   false,
            reportDownloading           :   false,
        });
       let params                       =   {from:page ,...this.state.submittedReportFilterForm,action:"data"};   

         //Api to call Lisitng 
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, params , {} , (response) => {
            let respData                =   response.data;
            this.setState({
                listingData                 :   merge_list == true ? respData.data : [...this.state.listingData, ...respData.data],
                reportDownloadBtn           :   true,
                listingMeta                 :   {
                    next                        :   respData.next,
                    till                          :   respData.till,
                }
            });
           
        }).then(() => {
            this.setState({listing_loading: false});
        });
    }

    loadMoreList                            =   ()  =>  {
        if(this.state.listingMeta && this.state.listingMeta.next == true) {
            this.loadListingTblData(this.state.listingMeta.till);
        }
    }
    
    reportDownloadHandler                   =   ()  =>  {
        this.setState({ reportDownloading: true});
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, {...this.state.submittedReportFilterForm, action : 'download'} , {} , (response) => DownloadFile.file(response.data.file_path,response.data.msg,response.data.navigation,this.props)).then(() => this.setState({reportDownloading: false}));
    }
    
    reportFilterhandler                     =   (collapse = true)  =>  {
        collapse && new Collapse(document.getElementById('reportFilterForm'));
        if(document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    closeReport                             =   ()  =>  {
        this.props.history.goBack()
    }
    
    pageTitleBarJsx                         =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                <h3><tapIcon.FontAwesomeIcon icon={tapIcon.faCubes} /> {this.state.reportData?.name}</h3>
                <div className="text-end mt15">
                    {this.state.reportDownloadBtn ? (<button disabled={this.state.reportDownloading || this.state.reportData?.download_access === 'N'} type="button" onClick={this.reportDownloadHandler} className="btn btn-primary"><tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} /> Download Detailed Report {this.state.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin"/>) : ''}</button>) : null}
                    <button type="button" onClick={this.reportFilterhandler} className="btn btn-secondary">Change Filter</button>
                    <button type="button" disabled={!this.state.formDataLoaded} className="btn btn-secondary mx-1" onClick={this.closeReport}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
                    </button>
                </div>
            </div>
        </div>);
    }
    
    reportFilterFormJsx                     =   ()  => {
        return (<div id="reportFilterForm" className="bg-white collapse " >
            <form onSubmit={(e) => this.reportFilterFormSubmit(e,true)} className={['p-3', 'filter_form'].join(' ')}>
              
            <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Site Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allSiteGroupsList}
                            changeEvent={(selectedOption) => {
                               
                               this.setState({
                                 reportFilterForm     :   {
                                     ...this.state.reportFilterForm,
                                     site_group_ids             :   selectedOption &&  selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                     search_site_ids            :   selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_sites).flat() : []
                                 }
                               })
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allSiteGroupsList.filter(s => this.state.reportFilterForm.site_group_ids.includes(s.value))}
                            placeholder="Select Site Group"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Site Name</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_user_sites}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_site_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.iam_user_sites.filter(s => this.state.reportFilterForm.search_site_ids.includes(s.value))}
                            placeholder="Select Sites"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Type Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allAssetTypesGroupsList}
                            changeEvent={(selectedOption) => {

                                this.setState({
                                    reportFilterForm: {
                                        ...this.state.reportFilterForm,
                                        asset_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                        search_asset_type_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_asset_types).flat() : []
                                    }
                                })
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allAssetTypesGroupsList.filter(s => this.state.reportFilterForm.asset_group_ids.includes(s.value))}
                            placeholder="Select Asset Type Group"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_asset_types}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_asset_type_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.iam_asset_types.filter(s => this.state.reportFilterForm.search_asset_type_ids.includes(s.value))}
                            placeholder="Select Asset Type"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Matrix</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_asset_matrix}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_asset_matrix_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.iam_asset_matrix.filter(s => this.state.reportFilterForm.search_asset_matrix_ids.includes(s.value))}
                            placeholder="Select Asset Matrix"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Manufacturer</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_manufactures}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_manufacturer_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.iam_manufactures.filter(s => this.state.reportFilterForm.search_manufacturer_ids.includes(s.value))}
                            placeholder="Select Manufacturer"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Model</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_models}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_models');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.iam_models.filter(s => this.state.reportFilterForm.search_models.includes(s.value))}
                            placeholder="Select Models"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Name</label>
                    <div className="col-sm-6">
                        <InputAssetSearch
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_asset_ids');
                                this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                            }}
                            search_asset_type={[this.state.reportFilterForm.search_asset_type]}
                            isMulti={true}
                            value={this.state.searchedAssets && this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
               
                {/* <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Ownership</label>
                    <div className="col-sm-6">
                        <div className='row'>
                            <div className='col-sm-5'>
                                <TapSelect
                                    menuPlacement='top'
                                    options={this.state.allOwnershipCategory}
                                    changeEvent={(selectedOption) => {
                                        this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_ownership_category');
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={this.state.allOwnershipCategory.find(r => r.value === this.state.reportFilterForm.search_ownership_category)}
                                    placeholder="Select Ownership Category"
                                />
                            </div>
                            <div className='col-sm-7'>
                                <TapSelect
                                    menuPlacement='top'
                                    options={this.state.allOwnersList}
                                    changeEvent={(selectedOption) => {
                                        this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_owner_id');
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={this.state.allOwnersList.find(r => r.value === this.state.reportFilterForm.search_owner_id)}
                                    placeholder="Select Owner"
                                />
                            </div>
                        </div>


                    </div>
                </div> */}
                 <CommonOwnerShipCategorySearch
                  onChange={this.handleOwnerCategoryChange}
                  onDataLoad={this.handleOwnerDataLoad}
                  value={this.state.reportFilterForm}
                />
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Utilization Status (based on Total Hrs)</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allStatus}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_status');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allStatus.filter(s => this.state.reportFilterForm.search_status.includes(s.value))}
                            placeholder="Select Status"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end require">Date Range</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods={this.state.all_periods ? this.state.all_periods : []}
                            value={this.state.reportFilterForm.date_range}
                            startDate={this.state.reportFilterForm.date_range_start}
                            endDate={this.state.reportFilterForm.date_range_end}
                            required={true}
                            onSelectPeriod={(period, startDate, endDate) => {
                                this.setState({
                                    reportFilterForm
                                        : {
                                        ...this.state.reportFilterForm,
                                        date_range: period,
                                        date_range_start: startDate ? startDate : null,
                                        date_range_end: endDate ? endDate : null
                                    }
                                });
                            }}

                        />
                    </div>
                   
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={this.state.listing_loading ? true : false} className="btn btn-primary px-4">Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        </div>);
    }
    
    reportListingDisplayJsx                 =   ()  =>  {
        return (<div className="bg-white">

            {this.state.listingMeta && this.reportTableJsx()
            }
            <div className='bg-white text-center'>
                {this.state.listing_loading
                    ? (<Loader />)
                    : (null)}
            </div>
        </div>)
    }
    
    reportTableJsx                          =   ()  =>  {
        return (<Ax>
            <table className="table table-bordered table-sm align-middle bg-white my-2">
                <thead className="align-middle table-secondary" style={{
                    top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr>
                        <th scope="col" style={{ width: "14%" }}>Asset</th>
                       <th scope="col" style={{ width: "14%" }}>Site</th>
                        <th scope="col" style={{ width: "8%" }}>Planned Hrs</th>
                        <th scope="col" style={{ width: "8%" }}>Hrs Run</th>
                        <th scope="col" style={{ width: "8%" }}>Utilisation based on Planned Hrs </th>
                        <th scope="col" style={{ width: "8%" }}>Utilisation based on Total Hrs </th>
                        <th scope="col" style={{ width: "8%" }}>Planned KM </th>
                        <th scope="col" style={{ width: "8%" }}>KM Run </th>
                        <th scope="col" style={{ width: "8%" }}>Utilization based on Planned KM.</th>
                        <th scope="col" style={{ width: "8%" }}>Downtime</th>
                        <th scope="col" style={{ width: "8%" }}>Availability %</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.listingData && this.state.listingData.length > 0
                        ? (this.state.listingData.map((data, index) => {
                           let utilization = data && data.utilization ? data.utilization : null;
                           let availabilty = data && data.availabilty ? data.availabilty : null;
                           let hr_meter = data && data.cl && data.cl.length > 0 ? data.cl.find(meter => meter.key == "hour_meter") : null;
                           let km_meter = data && data.cl && data.cl.length > 0 ? data.cl.find(meter => meter.key == "odo_meter") : null;
                            return (<tr className="text-end">
                                    <td className="text-start"><Link to={`/asset/dashboard/${data.asset_id}?=Y`} role="button" className="link-primary">{data?.asset_name}</Link><br/><small>Code: {data?.asset_code}</small></td>
                                    <td className="text-start">{data.site ? data.site : "-"}</td>
                                   <td>{utilization && utilization.planned_hr ? utilization.planned_hr : ""} </td>
                                   <td>{hr_meter && hr_meter.running_display ? hr_meter.running_display : ""} </td>
                                   <td>{utilization && utilization.utilization_planned_hr ? utilization.utilization_planned_hr : ""} </td>
                                   <td>{utilization && utilization.utilization_total_hr ? utilization.utilization_total_hr : ""} </td>
                                   <td>{utilization && utilization.planned_km ? utilization.planned_km : ""} </td>
                                   <td>{km_meter && km_meter.running_display ? km_meter.running_display : ""}</td>
                                   <td>{utilization && utilization.utilization_planned_km ? utilization.utilization_planned_km : ""} </td>
                                   <td>{availabilty && availabilty.downtime_sec ? DateService.convertSeconds(availabilty.downtime_sec) : ""}</td>
                                   <td>{availabilty && availabilty.availabilty ? availabilty.availabilty : ""} </td>
                                </tr>)
                        }))
                        : <tr><td className="text-center" colSpan={11}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
        </Ax>);
    }

    render                                  =   ()  =>  {
        return (<ApplicationLayout>
            <Helmet><title>Report - Asset Wise Utilisation and Availability</title></Helmet>
            {this.pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                    {this.state.formDataLoaded
                            ? (<Ax>
                                {this.reportFilterFormJsx()}
                                <div ref={this.criteriaRef}
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        background: 'white',
                                    }}>
                                 <DisplaySearchCriteria searchedElems={this.state.formSearchedElems}  onClearFilter={this.reportSearchClear} /> 
                                 </div>
                                {this.reportListingDisplayJsx()}

                            </Ax>)
                            : <Loader />
                        }
                        <div className='d-flex justify-content-between bg-white py-2'>
                        {this.state.listingMeta && <div>Total Displayed Records : {this.state.listingData && this.state.listingData.length > 0 && <span>{this.state.listingData.length}</span>}</div>}
                            <div>
                                {this.state.listingMeta && this.state.listingMeta.next
                                    ? <button type="button" className="btn btn-secondary me-3 " style={{ lineHeight: "6.3px!important", height: "27px" }} onClick={() => this.loadMoreList()} >Load More</button>
                                    : null}
                            </div>
                        </div>
                        

                    </div>
                </div>
            </div>
        </ApplicationLayout>);
    }
    
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        fuel_stations           :   state.app && state.app.fuel_stations ? state.app.fuel_stations : [],
        iam_asset_types         :   state.app && state.app.asset_type ? state.app.asset_type : [],
        iam_manufactures        :   state.app && state.app.manufactures ? state.app.manufactures : [],
        iam_models              :   state.app && state.app.models ? state.app.models : [],
        asset_groups             :   state.app && state.app.asset_groups ? state.app.asset_groups : [],
        iam_asset_matrix        :   state.app && state.app.asset_matrix ? state.app.asset_matrix : [], 
        report_listing          :   state.app && state.app.report_listing && state.app.report_listing.length > 0 ? state.app.report_listing : []   
    };
};

export default connect(mapStateToProps)(AssetSegrationReport);